<template>
  <div class="product-grid product-card-horizontal-mobile" id="product-grid">
    <h2 v-html="title" v-if="title"></h2>
    <v-row class="mt-1 mt-sm-0">
      <template v-for="(product, idx) in products">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
          v-if="findProductCardSponsor(idx)"
          :key="`product-card-${idx}`"
          class="product-col product-col-card-special"
        >
          <ProposalCardOverlay
            :proposal="findProductCardSponsor(idx)"
          ></ProposalCardOverlay>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
          :key="product.productId"
          class="product-col"
        >
          <ProductCard v-bind:product="product" />
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
import ProductCard from "./ProductCard.vue";
import ProposalCardOverlay from "@/components/categoryBlock/elements/ProposalCardOverlay.vue";

import ProductService from "~/service/productService";

import { mapGetters } from "vuex";

export default {
  components: { ProductCard, ProposalCardOverlay },
  name: "ProductGrid",
  props: {
    productList: { type: Array, required: false },
    categoryId: { type: Number, required: false },
    productId: { type: Number, required: false },
    layout: { type: Number, required: false },
    shuffle: { type: Boolean, required: false, default: false },
    promo: { type: Boolean, required: false, default: false },
    limit: { type: Number, required: false, default: 12 },
    title: { type: String, required: false },
    proposal: { type: Object, required: false },
    paginationClass: { type: String, required: false },
    cols: { default: 1 },
    sm: { default: 2 },
    md: { default: 3 },
    lg: { default: 4 },
    xl: { default: 6 },
    showArrows: { type: Boolean, default: true },
    showBullets: { type: Boolean, default: true }
  },

  data() {
    return {
      products: [],
      swiperOption: {
        slidesPerGroup: 1,
        spaceBetween: 20,
        watchOverflow: true,
        pagination: {
          el: `#product-list-pagination-${this.paginationClass}`,
          clickable: true
        },
        navigation: {
          prevEl: `#product-list-slider-prev-${this.paginationClass}`,
          nextEl: `#product-list-slider-next-${this.paginationClass}`
        },
        breakpoints: {
          0: {
            slidesPerView: this.cols
          },
          600: {
            slidesPerView: this.sm
          },
          960: {
            slidesPerView: this.md
          },
          1264: {
            slidesPerView: this.lg
          },
          1900: {
            slidesPerView: this.xl
          }
        }
      }
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchProducts();
  },
  computed: {
    ...mapGetters({
      categoryBlocks: "category/categoryBlocks"
    }),
    productCardSponsorProposals() {
      if (this.categoryBlocks) {
        let card = this.categoryBlocks.find(
          block => block.templateBlock.codInt == "productcard"
        );
        return card && card.proposals && card.proposals.length > 0
          ? card.proposals
          : null;
      }
      return null;
    }
  },
  methods: {
    findProductCardSponsor(idx) {
      if (this.productCardSponsorProposals) {
        let proposalOnIdx = this.productCardSponsorProposals.find(
          proposal => proposal.priority == idx
        );
        return proposalOnIdx ? proposalOnIdx : null;
      }
      return null;
    },
    async fetchProducts() {
      if (this.productList) {
        this.products = this.productList;
      } else if (this.proposal) {
        let response = await ProductService.search({
          parent_category_id: this.proposal.categoryProposedId,
          page_size: this.limit
        });
        this.products = response.products;
      } else {
        let response = await ProductService.adv({
          layout: this.layout,
          product_id: this.productId,
          category_id: this.categoryId,
          limit: this.limit,
          shuffle: this.shuffle,
          promo: this.promo
        });
        this.products = response.products;
      }
    }
  }
};
</script>
